import React from 'react';
import { motion } from 'framer-motion';
import './YoutubeMakeItWork.css';

const YoutubeMakeItWork = () => {
  const textVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: "easeOut" } }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (custom) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: custom * 0.2, ease: "easeOut" }
    })
  };

  return (
    <section className="yt-miw-section modern">
      <motion.div 
        className="yt-miw-content"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={textVariants}
      >
        <p className="yt-hero-tag">
          <span className="tag-muted">BUILT FOR ARTISTS</span>
        </p>
        <h2 className="yt-miw-title">
          MAKE YOUTUBE<br/>
          WORK FOR<br/>
          <span className="gradient-text-purple-pink">YOUR MUSIC</span>
        </h2>
        <p className="yt-miw-desc">
          Our strategy focuses on real engagement,
          targeted exposure, and sustainable growth
          that converts.
        </p>
        <a 
          href="https://dashboard.fttunes.com/register.php"
          target="_blank"
          rel="noopener noreferrer"
          className="yt-btn-secondary"
          style={{ textDecoration: 'none', display: 'inline-block' }}
        >
          Sign Up <span className="arrow">→</span>
        </a>
      </motion.div>

      <motion.div 
        className="yt-miw-visual-modern"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <div className="miw-image-container">
          <motion.img 
            variants={imageVariants}
            src="/youtube-assets/miw_center.png" 
            alt="Premium Play Button Monument" 
            className="miw-center-img" 
          />
          
          <motion.div variants={cardVariants} custom={1} className="miw-glass-card card-tl">
            <div className="mg-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg></div>
            <div className="mg-text">
               <h4>REAL AUDIENCE</h4>
               <p>Genuine engagement</p>
            </div>
          </motion.div>

          <motion.div variants={cardVariants} custom={2} className="miw-glass-card card-tr">
            <div className="mg-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg></div>
            <div className="mg-text">
               <h4>SMART GROWTH</h4>
               <p>Data-driven scaling</p>
            </div>
          </motion.div>

          <motion.div variants={cardVariants} custom={3} className="miw-glass-card card-bl">
            <div className="mg-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle></svg></div>
            <div className="mg-text">
               <h4>MORE PLAYS</h4>
               <p>Increase streams</p>
            </div>
          </motion.div>

          <motion.div variants={cardVariants} custom={4} className="miw-glass-card card-br">
            <div className="mg-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg></div>
            <div className="mg-text">
               <h4>BETTER RESULTS</h4>
               <p>Higher conversion</p>
            </div>
          </motion.div>

        </div>
      </motion.div>
    </section>
  );
};

export default YoutubeMakeItWork;
